module.exports = __webpack_public_path__ + "img/P8_popup_thumb_5_cn.43e77ff3.png";